import { render, staticRenderFns } from "./AppBottomNavigation.vue?vue&type=template&id=2dd75008&"
import script from "./AppBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./AppBottomNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppBottomNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports